/**
 * Owner-standard card number renderer (2026-09-01).
 *
 * Rules:
 *  - Standard cards: `{localId}/{cardCount.official}` — e.g. Ninetales
 *    base1-12 = "12/102". Uses TCGdex `cardCount.official` (printed on
 *    the card face), NOT `cardCount.total`.
 *  - Promos / irregular numbering: `{localId}` alone (with any prefix
 *    already baked into the localId, e.g. "SVP150"). No fraction.
 *  - Trigger for promo mode: `cardCount.official` is missing/zero OR
 *    `localId` is non-numeric.
 *  - Fallback: if localId is empty/null, return "" so callers can hide
 *    the field. Never returns "—" as filler.
 *
 * Decision is PER-CARD from data, never per-set hardcoded.
 *
 * @param {{ localId?: string|number|null,
 *           cardCountOfficial?: number|null,
 *           setCode?: string|null }} opts
 * @returns {string}
 */
export function formatCardNumber({ localId, cardCountOfficial, setCode }) {
  if (localId === null || localId === undefined || localId === "") return "";
  const s = String(localId).trim();
  if (!s) return "";

  const numeric = /^\d+$/.test(s);
  const officialPresent =
    typeof cardCountOfficial === "number" && cardCountOfficial > 0;

  if (numeric && officialPresent) {
    return `${s}/${cardCountOfficial}`;
  }

  // Promo / irregular. If localId already carries a prefix (non-numeric
  // like "SVP150"), return as-is. If it's plain numeric but the set has
  // no official count (rare promo edge case), prepend the setCode so the
  // number is disambiguable — e.g. localId="150" + setCode="svp" =>
  // "SVP 150".
  if (numeric && setCode) {
    return `${String(setCode).toUpperCase()} ${s}`;
  }
  return s;
}
